var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 334 88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M296.1,43.2c2.4,0,4.4,0.8,5.9,2.4c1.4,1.6,2.1,3.5,2.1,6c0,2.4-0.7,4.4-2.1,6c-1.5,1.6-3.5,2.4-5.9,2.4 c-2.4,0-4.4-0.8-5.9-2.4c-1.4-1.6-2.1-3.5-2.1-6c0-2.4,0.7-4.4,2.1-6C291.7,44.1,293.7,43.2,296.1,43.2z M296.1,57.8 c1.8,0,3.1-0.6,4.2-1.8c1-1.1,1.5-2.6,1.5-4.4c0-1.8-0.5-3.2-1.5-4.4c-1-1.2-2.4-1.8-4.2-1.8c-1.8,0-3.1,0.6-4.2,1.8 c-1,1.2-1.5,2.6-1.5,4.4c0,1.8,0.5,3.2,1.5,4.4C293,57.2,294.4,57.8,296.1,57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M296.1,60.5c-2.6,0-4.7-0.9-6.3-2.6c-1.5-1.7-2.3-3.8-2.3-6.3s0.8-4.6,2.3-6.3c1.6-1.7,3.7-2.6,6.3-2.6 c2.6,0,4.7,0.9,6.3,2.6c1.5,1.7,2.3,3.8,2.3,6.3s-0.8,4.6-2.3,6.3C300.8,59.7,298.7,60.5,296.1,60.5z M296.1,43.7 c-2.3,0-4.1,0.7-5.6,2.3c-1.3,1.5-2,3.3-2,5.6s0.7,4.2,2,5.6c1.4,1.5,3.2,2.3,5.6,2.3c2.3,0,4.1-0.7,5.6-2.3 c1.3-1.5,2-3.3,2-5.6s-0.7-4.2-2-5.6C300.2,44.5,298.4,43.7,296.1,43.7z M296.1,58.3c-1.9,0-3.4-0.7-4.5-2 c-1-1.2-1.6-2.8-1.6-4.7s0.5-3.4,1.6-4.7c1.1-1.3,2.6-2,4.5-2c1.9,0,3.4,0.7,4.5,2c1,1.2,1.6,2.8,1.6,4.7s-0.5,3.4-1.6,4.7 C299.5,57.6,298,58.3,296.1,58.3z M296.1,45.9c-1.6,0-2.9,0.5-3.8,1.6c-0.9,1.1-1.3,2.4-1.3,4s0.5,3,1.3,4 c0.9,1.1,2.2,1.6,3.8,1.6c1.6,0,2.9-0.5,3.8-1.6c0.9-1.1,1.3-2.4,1.3-4s-0.5-3-1.3-4C299,46.5,297.7,45.9,296.1,45.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M316,43.2v2.4h-0.3c-1.8,0-3.2,0.7-4.3,2.1c-1,1.3-1.6,3-1.6,4.8v7.2h-2.4V43.5h2.4v4 c0.5-1.7,1.6-2.9,3.4-3.7c0.7-0.3,1.6-0.5,2.6-0.5H316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M310.3,60.3h-3.4V43h3.4v2.4c0.7-0.9,1.5-1.6,2.7-2.1c0.8-0.4,1.7-0.6,2.8-0.6h0.7v3.4h-0.8 c-1.6,0-2.9,0.6-3.9,1.9c-1,1.2-1.5,2.8-1.5,4.5V60.3z M307.9,59.3h1.4v-6.7c0-2,0.6-3.7,1.7-5.1c1.2-1.5,2.7-2.3,4.5-2.3v-1.4 c-0.8,0-1.5,0.2-2,0.5c-1.6,0.8-2.6,1.9-3.1,3.4l-1,3.2V44h-1.4V59.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M330.9,46.1v-2.6h2.4v15.8c0,2.3-0.7,4.1-2,5.4c-1.3,1.2-3.1,1.8-5.4,1.8c-2.3,0-4-0.4-5.3-1.3 c-1.3-0.9-2.1-2-2.6-3.4h2.7c0.7,1.7,2.3,2.5,4.8,2.5c1.9,0,3.3-0.4,4.1-1.3c0.8-0.9,1.3-2.1,1.3-3.8v-2.2 c-1.3,1.9-3.3,2.9-5.8,2.9c-2.3,0-4.3-0.8-5.7-2.4c-1.4-1.6-2.1-3.5-2.1-5.9c0-2.3,0.7-4.3,2.1-5.9c1.5-1.6,3.4-2.4,5.9-2.4 C327.7,43.2,329.6,44.2,330.9,46.1z M325.4,57.6c0.9,0,1.7-0.2,2.4-0.5c0.7-0.3,1.3-0.7,1.8-1.3c1-1.1,1.5-2.6,1.5-4.3 s-0.5-3.2-1.5-4.3c-1.1-1.2-2.5-1.8-4.2-1.8c-1.8,0-3.2,0.6-4.2,1.8c-1,1.2-1.5,2.6-1.5,4.3c0,1.7,0.5,3.1,1.5,4.3 C322.2,57,323.6,57.6,325.4,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M326,67c-2.3,0-4.2-0.5-5.6-1.4c-1.4-0.9-2.3-2.2-2.8-3.7l-0.2-0.7h3.7l0.1,0.3c0.6,1.5,2,2.2,4.3,2.2 c1.7,0,3-0.4,3.7-1.2c0.7-0.8,1.1-1.9,1.1-3.5v-0.9c-1.4,1.3-3.1,2-5.3,2c-2.5,0-4.5-0.9-6.1-2.6c-1.5-1.7-2.3-3.7-2.3-6.2 s0.8-4.5,2.3-6.2c1.6-1.7,3.7-2.6,6.3-2.6c2.1,0,3.8,0.7,5.1,2V43h3.4v16.3c0,2.5-0.7,4.4-2.2,5.7C330.3,66.3,328.3,67,326,67z  M318.8,62.2c0.5,1,1.2,1.9,2.1,2.5c1.2,0.8,2.9,1.2,5,1.2c2.1,0,3.8-0.6,5-1.7c1.2-1.1,1.8-2.8,1.8-5V44h-1.4v3.7l-0.9-1.3 c-1.2-1.8-2.9-2.6-5.2-2.6c-2.3,0-4.2,0.7-5.5,2.2c-1.3,1.5-2,3.3-2,5.5c0,2.2,0.7,4.1,2,5.5c1.4,1.5,3.1,2.2,5.4,2.2 c2.4,0,4.2-0.9,5.4-2.7l0.9-1.3v3.9c0,1.8-0.5,3.2-1.4,4.2c-0.9,1-2.4,1.5-4.5,1.5c-2.5,0-4.2-0.9-5.1-2.5H318.8z M325.4,58.1 c-1.9,0-3.4-0.6-4.6-1.9c-1.1-1.2-1.7-2.8-1.7-4.6c0-1.8,0.6-3.4,1.7-4.6c1.2-1.3,2.7-1.9,4.6-1.9c1.9,0,3.4,0.6,4.5,1.9 c1.1,1.2,1.6,2.8,1.6,4.6s-0.5,3.4-1.6,4.6c-0.6,0.6-1.2,1.1-2,1.4C327.2,57.9,326.4,58.1,325.4,58.1z M325.4,45.9 c-1.6,0-2.9,0.5-3.9,1.6c-0.9,1.1-1.4,2.4-1.4,4c0,1.6,0.5,2.9,1.4,4c1,1.1,2.2,1.6,3.9,1.6c0.8,0,1.5-0.1,2.2-0.4 c0.6-0.3,1.2-0.7,1.6-1.2c0.9-1,1.3-2.4,1.3-4s-0.5-2.9-1.3-4C328.2,46.5,327,45.9,325.4,45.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 281.1,
    y: 56.6,
    fill: "#0090D0",
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0090D0",
    d: "M284.7,60.3h-4.1v-4.1h4.1V60.3z M281.6,59.3h2.1v-2.1h-2.1V59.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    fill: "#0090D0",
    d: "M95.1,27.8c-4.5,0-8.1,1.5-10.6,4.5v-4h-5.6v44.3h5.6V56.2c2.5,3,6,4.6,10.3,4.6 c4.8,0,8.7-1.6,11.5-4.8c2.8-3.1,4.3-7.1,4.3-11.7c0-4.6-1.4-8.5-4.3-11.7C103.5,29.4,99.7,27.8,95.1,27.8z M102.2,52.3 c-2,2.2-4.6,3.3-7.7,3.3c-3.2,0-5.7-1.1-7.6-3.3c-1.8-2.1-2.7-4.8-2.7-8c0-3.2,0.9-5.9,2.7-8c1.8-2.2,4.4-3.3,7.6-3.3 c3.2,0,5.7,1.1,7.7,3.3c1.9,2.1,2.8,4.8,2.8,8S104.1,50.2,102.2,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    fill: "#0090D0",
    d: "M140,32.4c-2.5-3-6-4.6-10.3-4.6c-4.8,0-8.7,1.6-11.6,4.8c-2.8,3.1-4.2,7.1-4.2,11.7 c0,4.6,1.4,8.5,4.2,11.7c2.9,3.2,6.7,4.8,11.3,4.8c4.5,0,8.1-1.5,10.6-4.5v4h5.6v-32H140V32.4z M137.6,52.3 c-1.8,2.2-4.4,3.3-7.6,3.3c-3.2,0-5.7-1.1-7.7-3.3c-1.9-2.1-2.8-4.8-2.8-8s0.9-5.9,2.8-8c2-2.2,4.6-3.3,7.7-3.3 c3.2,0,5.7,1.1,7.6,3.3c1.8,2.1,2.7,4.8,2.7,8C140.3,47.5,139.4,50.2,137.6,52.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_109_",
    fill: "#0090D0",
    points: "162.5,17.2 156.9,17.2 156.9,28.3 152.8,28.3 148.8,33.3 156.9,33.3 156.9,60.3  162.5,60.3 162.5,33.3 166.9,33.3 170.9,28.3 162.5,28.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_108_",
    fill: "#0090D0",
    points: "183.1,17.2 177.4,17.2 177.4,28.3 173.4,28.3 169.4,33.3 177.4,33.3 177.4,60.3  183.1,60.3 183.1,33.3 187.5,33.3 191.4,28.3 183.1,28.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    fill: "#0090D0",
    d: "M205.9,27.8c-4.8,0-8.7,1.6-11.7,4.8c-2.8,3.1-4.2,7-4.2,11.7c0,4.7,1.5,8.6,4.4,11.7 c3,3.2,7,4.8,11.8,4.8c3.8,0,6.9-0.9,9.3-2.7c2.4-1.8,4.2-4.2,5.3-7l0.2-0.6H215l-0.1,0.3c-1.7,3.3-4.6,5-8.6,5 c-2.9,0-5.4-0.9-7.2-2.7c-1.7-1.7-2.8-3.8-3.2-6.3h25.9v-2.3c0-4.7-1.4-8.6-4.2-11.7C214.6,29.4,210.7,27.8,205.9,27.8z  M195.9,41.3c0.5-2.4,1.5-4.3,3.1-5.8c1.8-1.7,4.2-2.5,6.9-2.5c2.7,0,5,0.9,6.9,2.5c1.6,1.5,2.7,3.5,3.1,5.8H195.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    fill: "#0090D0",
    d: "M238,28.8c-2.6,1.2-4.6,3-5.8,5.2v-5.7h-5.6v32h5.6V46.1c0-3.4,1-6.4,2.9-8.9 c2-2.6,4.6-3.9,7.8-3.9h1v-5.6h-0.8C241.2,27.8,239.4,28.1,238,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    fill: "#0090D0",
    d: "M272.5,31.4c-1.2-1.2-2.5-2.1-4.1-2.7c-1.5-0.6-3.4-0.9-5.5-0.9c-2.2,0-4.1,0.5-5.8,1.6 c-1.3,0.8-2.4,1.8-3.4,2.9v-4h-5.6v32h5.6V41.9c0-2.6,0.9-4.8,2.6-6.5c1.7-1.6,3.8-2.5,6.3-2.5c2.4,0,4.4,0.8,5.9,2.4 c1.5,1.6,2.3,3.8,2.3,6.5v18.4h5.6V41.7C276.4,37.5,275.1,34,272.5,31.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_90_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_101_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_102_",
    fill: "#F9A51A",
    points: "49.1,28 49.1,22.9 39.5,14.2 39.5,28  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_100_",
    x: 0.2,
    y: 29.9,
    fill: "#24B57C",
    width: 18.2,
    height: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_99_",
    x: 31.8,
    y: 29.9,
    fill: "#24B57C",
    width: 37.4,
    height: 9.6
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_97_",
    x: 51,
    y: 49.1,
    fill: "#0090D0",
    width: 18.2,
    height: 9.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_96_",
    fill: "#F9A51A",
    points: "49.1,87.2 49.1,41.4 39.5,41.4 39.5,78.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_95_",
    x: 0.2,
    y: 49.1,
    fill: "#0090D0",
    width: 37.4,
    height: 9.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_93_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_94_",
    fill: "#0090D0",
    points: "20.3,60.6 20.3,65.1 29.9,73.8 29.9,60.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_92_",
    fill: "#0090D0",
    points: "29.9,47.2 29.9,9.4 20.3,0.8 20.3,47.2  "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPattern);
export default __webpack_public_path__ + "static/media/logo-pattern.f5155856370c493c7fedfe17247494f2.svg";
export { ForwardRef as ReactComponent };